var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9485_11733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5141 2.98594L15.0282 0.5L12.1279 3.40027L14.1996 8.78645L17.5141 2.98594Z",
    fill: "#A744EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.514 2.98593L12.9565 7.54347L17.0997 8.3721L20 5.47187L17.514 2.98593Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33656 16.379L0 20.5L4.38609 17.7712L1.33656 16.379Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5L4.12098 19.1635L3.55738 16.9426L0 20.5Z",
    fill: "#A744EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35847 14.799L2.38663 13.1417L1.33667 16.379L2.7289 17.7713L7.35847 14.799Z",
    fill: "#CCB5DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72876 17.7712L4.12103 19.1635L7.35829 18.1135L6.52966 13.9703L2.72876 17.7712Z",
    fill: "#EBE0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87231 15.6276L7.3582 18.1135L17.0997 8.37209L14.6138 5.8862L8.12281 9.06259L4.87231 15.6276Z",
    fill: "#A744EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3855 13.1411L12.1255 3.40115L14.611 5.88669L4.87104 15.6267L2.3855 13.1411Z",
    fill: "#8E24D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9485_11733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.67261571b9bf1556f92e1199982aadb9.svg";
export { ForwardRef as ReactComponent };